module.exports = __webpack_public_path__ + "img/beam-tail.9da1d693.png";